module.exports = __webpack_public_path__ + "img/8A6565_2E214D_D48A5F_ADA59C-256px.57814cd9.png";